import { Card, Box, Grid } from '@mui/material';
import React from 'react';
import { WsTypography, WsTypoVariants, WsTypoColors } from 'wisestep-base';

export interface INoDataFoundCard {
  text: string;
  subElement?: React.ReactElement;
  icon?: React.ReactElement;
}

const NoDataFoundCard = ({ text, subElement, icon }: INoDataFoundCard) => (
  <Card sx={{ minHeight: 300, alignItems: 'center', width: '100%' }}>
    <Box textAlign="center" pt={icon ? 10 : 15} px={4}>
      {icon && icon}
      {subElement && subElement}
      <Grid pb={icon ? 10 : 15}>
        <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.SECONDARY}>
          {text}
        </WsTypography>
      </Grid>
    </Box>
  </Card>
);

export default NoDataFoundCard;
